module.exports = __webpack_public_path__ + "img/grand-palm-family-2.f83aedc4.jpg";